import { render, staticRenderFns } from "./BeneficiaryMoral.vue?vue&type=template&id=79fba987&scoped=true&"
import script from "./BeneficiaryMoral.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryMoral.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryMoral.vue?vue&type=style&index=0&id=79fba987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fba987",
  null
  
)

export default component.exports